export default async ({ store, route, redirect }) => {

    /*await store.dispatch('language/getAll')

    if (store.getters.isAuthenticated){
        await store.dispatch('dictionary/getDataDictionaryGroup')
        await store.dispatch('dictionary/getDataDictionary')
    }

    */

    await store.dispatch('language/setDir')

}
